/**
 * Caché chica en IndexedDB (clave → valor serializable), sin dependencias.
 *
 * Para lo que NO cabe con seguridad en `localStorage` (~5 MB por origen): hoy,
 * la copia del día del export de clientes (~14 mil filas). Cada lectura de
 * Firestore se paga (CLAUDE.md raíz): guardar aquí lo que ya se leyó es lo que
 * permite volver a descargar el archivo sin releer la colección.
 *
 * Todo puede fallar (modo privado, cuota, navegador viejo): quien la usa trata
 * el error como "no hay caché" y sigue.
 */
const DB_NAME = 'krispis-admin-cache';
const STORE = 'kv';

const openDb = (): Promise<IDBDatabase> =>
    new Promise((resolve, reject) => {
        if (typeof indexedDB === 'undefined') {
            reject(new Error('IndexedDB no disponible'));
            return;
        }
        const request = indexedDB.open(DB_NAME, 1);
        request.onupgradeneeded = () => {
            if (!request.result.objectStoreNames.contains(STORE)) request.result.createObjectStore(STORE);
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });

export const idbGet = async <T>(key: string): Promise<T | undefined> => {
    const db = await openDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, 'readonly');
        const request = tx.objectStore(STORE).get(key);
        request.onsuccess = () => resolve(request.result as T | undefined);
        request.onerror = () => reject(request.error);
        tx.oncomplete = () => db.close();
    });
};

export const idbSet = async (key: string, value: unknown): Promise<void> => {
    const db = await openDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, 'readwrite');
        tx.objectStore(STORE).put(value, key);
        tx.oncomplete = () => {
            db.close();
            resolve();
        };
        tx.onerror = () => reject(tx.error);
    });
};
